import AppContext from './AppContext';

const BASE_URL = AppContext.baseUrl;

const Params= {
    BASE_URL 
};

export default Params;